import dayjs from 'dayjs'

// 二次封装 dayjs 使得其可以使用字符串类型的时间戳
function formatTime(time, template = 'YYYY-MM-DD HH:mm:ss') {
  if (!time) {
    return ''
  }
  let paramTime = time
  // 全为数字的字符串时转换为数字
  if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
    paramTime = Number(time)
  }
  return dayjs(paramTime).format(template)
}

export { formatTime }
